import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { ChatComponent } from './chat/chat.component';
import { HubtypeComponent } from './hubtype/hubtype.component';
import { HubtypeService } from './hubtype/hubtype.service';
import { KakaoComponent } from './kakao/kakao.component';
import { MochaComponent } from './mocha/mocha.component';
import { ApiChatService } from './services/api-chat.service';
import { ChatService } from './services/chat.service';
import { CreateChatComponent } from './store/chat.actions';
import { ChatEffects } from './store/chat.effects';
import { chatReducer } from './store/chat.reducer';
import { StyleAdvisorComponent } from './style-advisor/style-advisor.component';
import { UrlChatComponent } from './url-chat/url-chat.component';

import { WhatsappService } from '@shared/contact/whatsapp.service';
import { UiSvgIconModule } from '@shared/ui/svg-icon/svg-icon.module';
import { DialogModule } from '@ui/dialog/dialog.module';
import { LoadingComponent } from '@ui/loading/loading.component';

@NgModule({
    providers: [ApiChatService, ChatService, HubtypeService, WhatsappService],
    declarations: [
        ChatComponent,
        HubtypeComponent,
        KakaoComponent,
        MochaComponent,
        StyleAdvisorComponent,
        UrlChatComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        DialogModule,
        LoadingComponent,
        UiSvgIconModule,
        StoreModule.forFeature('chat', chatReducer),
        EffectsModule.forFeature([ChatEffects]),
        UiSvgIconModule,
    ],
    exports: [
        ChatComponent,
    ],
})
export class ChatModule {
    constructor(private readonly store: Store) {
        this.store.dispatch(CreateChatComponent());
    }
}
